const S = "rgba(34,21,51,0.78)";
const B = "#8E5A9E";
const BD = "#74427F";

const visuals = {
  bottle: (
    <>
      <rect x="82" y="42" width="36" height="18" rx="3" fill={BD} />
      <path d="M86 60 h28 v16 c14 8 18 18 18 34 v86 a10 10 0 0 1 -10 10 h-44 a10 10 0 0 1 -10 -10 v-86 c0 -16 4 -26 18 -34 z" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="68" y="118" width="64" height="46" fill={B} opacity="0.9" />
      <line x1="76" y1="133" x2="124" y2="133" stroke="#fff" strokeWidth="2" opacity="0.85" />
      <line x1="76" y1="143" x2="110" y2="143" stroke="#fff" strokeWidth="1.5" opacity="0.5" />
    </>
  ),
  oil: (
    <>
      <rect x="90" y="34" width="20" height="26" rx="3" fill={BD} />
      <line x1="100" y1="60" x2="100" y2="78" stroke={S} strokeWidth="2" />
      <path d="M78 78 h44 c10 14 14 26 14 44 v74 a12 12 0 0 1 -12 12 h-48 a12 12 0 0 1 -12 -12 v-74 c0 -18 4 -30 14 -44 z" fill="none" stroke={S} strokeWidth="2.5" />
      <path d="M64 150 h72 v46 a12 12 0 0 1 -12 12 h-48 a12 12 0 0 1 -12 -12 z" fill={B} opacity="0.3" />
      <circle cx="100" cy="176" r="9" fill={B} opacity="0.9" />
    </>
  ),
  spray: (
    <>
      <path d="M86 40 h34 v12 h-24 v14 h-10 z" fill={BD} />
      <rect x="76" y="66" width="48" height="14" rx="3" fill="none" stroke={S} strokeWidth="2.5" />
      <path d="M74 80 h52 l8 116 a12 12 0 0 1 -12 12 h-44 a12 12 0 0 1 -12 -12 z" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="72" y="120" width="58" height="40" fill={B} opacity="0.9" />
      <line x1="80" y1="134" x2="122" y2="134" stroke="#fff" strokeWidth="2" opacity="0.8" />
    </>
  ),
  dispenser: (
    <>
      <rect x="70" y="34" width="30" height="10" rx="2" fill={S} opacity="0.8" />
      <line x1="85" y1="44" x2="85" y2="62" stroke={S} strokeWidth="3" />
      <path d="M62 62 h46 v18 c10 6 14 16 14 30 v86 a12 12 0 0 1 -12 12 h-50 a12 12 0 0 1 -12 -12 v-86 c0 -14 4 -24 14 -30 z" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="48" y="124" width="74" height="44" fill={B} opacity="0.9" />
      <line x1="58" y1="139" x2="112" y2="139" stroke="#fff" strokeWidth="2" opacity="0.85" />
    </>
  ),
  tube: (
    <>
      <rect x="72" y="36" width="56" height="16" rx="4" fill={BD} />
      <path d="M72 52 h56 l-10 132 a14 14 0 0 1 -14 12 h-8 a14 14 0 0 1 -14 -12 z" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="76" y="92" width="48" height="52" fill={B} opacity="0.85" transform="skewY(-2)" />
      <line x1="84" y1="112" x2="116" y2="112" stroke="#fff" strokeWidth="2" opacity="0.8" />
    </>
  ),
  tin: (
    <>
      <ellipse cx="100" cy="72" rx="46" ry="12" fill="none" stroke={S} strokeWidth="2.5" />
      <path d="M54 72 v110 c0 7 21 14 46 14 s46 -7 46 -14 v-110" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="54" y="110" width="92" height="40" fill={B} opacity="0.85" />
      <line x1="66" y1="124" x2="134" y2="124" stroke="#fff" strokeWidth="2" opacity="0.8" />
    </>
  ),
  bar: (
    <>
      <rect x="46" y="110" width="108" height="58" rx="14" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="46" y="110" width="108" height="20" rx="10" fill={B} opacity="0.85" />
      <line x1="60" y1="148" x2="140" y2="148" stroke={S} strokeWidth="1.5" opacity="0.5" />
      <path d="M60 96 q40 -26 80 0" fill="none" stroke={B} strokeWidth="2" opacity="0.7" />
    </>
  ),
  kitbox: (
    <>
      <rect x="52" y="86" width="96" height="102" rx="6" fill="none" stroke={S} strokeWidth="2.5" />
      <path d="M52 112 h96" stroke={S} strokeWidth="2" opacity="0.6" />
      <path d="M100 86 v102" stroke={S} strokeWidth="1.5" opacity="0.4" />
      <rect x="66" y="128" width="68" height="36" fill={B} opacity="0.9" />
      <line x1="74" y1="141" x2="126" y2="141" stroke="#fff" strokeWidth="2" opacity="0.85" />
      <path d="M88 86 q12 -18 24 0" fill="none" stroke={S} strokeWidth="2" opacity="0.6" />
    </>
  ),
  comb: (
    <>
      <rect x="48" y="96" width="104" height="16" rx="8" fill={B} opacity="0.9" />
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
        <line key={i} x1={56 + i * 10} y1="112" x2={56 + i * 10} y2="152" stroke={S} strokeWidth="3" strokeLinecap="round" />
      ))}
    </>
  ),
  box: (
    <>
      <path d="M56 96 l14 -22 h60 l14 22 z" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="56" y="96" width="88" height="96" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="56" y="96" width="88" height="28" fill={B} opacity="0.85" />
      <line x1="70" y1="110" x2="130" y2="110" stroke="#fff" strokeWidth="2" opacity="0.8" />
      <circle cx="100" cy="156" r="14" fill="none" stroke={S} strokeWidth="2" opacity="0.6" />
    </>
  ),
  jerrycan: (
    <>
      <rect x="118" y="44" width="18" height="22" rx="3" fill={BD} />
      <path d="M64 66 h64 l10 12 v112 a14 14 0 0 1 -14 14 h-46 a14 14 0 0 1 -14 -14 z" fill="none" stroke={S} strokeWidth="2.5" />
      <path d="M78 66 q10 -18 36 -12" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="64" y="120" width="74" height="52" fill={B} opacity="0.9" />
      <line x1="74" y1="138" x2="128" y2="138" stroke="#fff" strokeWidth="2" opacity="0.85" />
      <line x1="74" y1="150" x2="112" y2="150" stroke="#fff" strokeWidth="1.5" opacity="0.5" />
    </>
  ),
  mop: (
    <>
      <line x1="100" y1="30" x2="100" y2="140" stroke={S} strokeWidth="4" strokeLinecap="round" />
      <rect x="86" y="136" width="28" height="14" rx="4" fill={BD} />
      {[0, 1, 2, 3, 4, 5, 6].map((i) => (
        <path key={i} d={`M${88 + i * 4} 150 q ${-6 + i * 2} 30 ${-10 + i * 3.4} 52`} fill="none" stroke={i % 2 ? B : S} strokeWidth="3" strokeLinecap="round" opacity={i % 2 ? 0.9 : 0.7} />
      ))}
    </>
  ),
  dustpan: (
    <>
      <line x1="128" y1="34" x2="112" y2="120" stroke={S} strokeWidth="4" strokeLinecap="round" />
      <path d="M58 160 h84 l-8 36 a8 8 0 0 1 -8 6 h-52 a8 8 0 0 1 -8 -6 z" fill={B} opacity="0.9" />
      <path d="M58 160 h84" stroke={S} strokeWidth="2.5" />
    </>
  ),
  bucket: (
    <>
      <path d="M56 92 h88 l-10 96 a12 12 0 0 1 -12 10 h-44 a12 12 0 0 1 -12 -10 z" fill="none" stroke={S} strokeWidth="2.5" />
      <path d="M62 92 q38 -34 76 0" fill="none" stroke={B} strokeWidth="3" />
      <rect x="60" y="120" width="80" height="34" fill={B} opacity="0.85" />
      <line x1="72" y1="137" x2="128" y2="137" stroke="#fff" strokeWidth="2" opacity="0.8" />
    </>
  ),
  machine: (
    <>
      <rect x="52" y="92" width="96" height="72" rx="10" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="52" y="92" width="96" height="26" rx="10" fill={B} opacity="0.9" />
      <path d="M70 92 v-22 a10 10 0 0 1 10 -10 h20" fill="none" stroke={S} strokeWidth="2.5" />
      <circle cx="78" cy="180" r="14" fill="none" stroke={S} strokeWidth="2.5" />
      <circle cx="122" cy="180" r="14" fill="none" stroke={S} strokeWidth="2.5" />
      <circle cx="78" cy="180" r="4" fill={B} />
      <circle cx="122" cy="180" r="4" fill={B} />
    </>
  ),
  diffuser: (
    <>
      <rect x="72" y="96" width="56" height="104" rx="14" fill="none" stroke={S} strokeWidth="2.5" />
      <rect x="72" y="96" width="56" height="30" rx="14" fill={B} opacity="0.9" />
      <line x1="100" y1="126" x2="100" y2="200" stroke={S} strokeWidth="1.5" opacity="0.4" />
      <path d="M88 84 q-6 -12 0 -22" fill="none" stroke={B} strokeWidth="2" opacity="0.8" />
      <path d="M100 80 q-6 -14 0 -26" fill="none" stroke={S} strokeWidth="2" opacity="0.6" />
      <path d="M112 84 q-6 -12 0 -22" fill="none" stroke={B} strokeWidth="2" opacity="0.8" />
    </>
  ),
};

export const ProductVisual = ({ type = "bottle", className = "" }) => (
  <svg viewBox="0 0 200 230" className={className} aria-hidden="true">
    {visuals[type] || visuals.bottle}
  </svg>
);
